import { Chosen } from '@harvesthq/porchlight'

import { useState, useEffect, useCallback, useRef } from 'preact/compat'

const getClientGroup = (groups, name) => {
  let group = groups.find((group) => group.name === name)

  if (!group) {
    group = { name, choices: [] }
    groups.push(group)
  }

  return group
}

export const ProjectSelect = ({
  closable,
  defaultProjectCode,
  defaultProjectId,
  defaultProjectName,
  onChosenEvent,
  onSelect,
  projects,
}) => {
  const [selectedProject, setSelectedProject] = useState()
  const [groups] = useState(
    projects.reduce((groups, { name, code, id, client }) => {
      const group = getClientGroup(groups, client.name)
      const combinedName = code ? `[${code}] ${name}` : name

      const choice = {
        text: combinedName,
        value: id,
        'data-analytics-element-id': 'project-choice',
        'data-analytics-project-id': id,
      }

      group.choices.push(choice)
      return groups
    }, [])
  )

  const [defaultProjectById] = useState(
    defaultProjectId && projects.find(({ id }) => id === defaultProjectId)
  )

  const [defaultProjectByCode] = useState(
    defaultProjectCode &&
      projects.find(({ code }) => code === defaultProjectCode)
  )

  const [defaultProjectByName] = useState(
    defaultProjectName &&
      projects.find(({ name }) => name === defaultProjectName)
  )

  const chosenRef = useRef(null)

  const selectProject = useCallback(
    (value) => {
      value = Number.parseInt(value, 10)
      setSelectedProject(value)
      onSelect(value)
      onChosenEvent()
    },
    [onSelect, onChosenEvent]
  )

  useEffect(() => {
    if (closable && selectedProject === undefined) {
      chosenRef.current?.focus()
    }
  }, [closable, selectedProject])

  useEffect(() => {
    if (selectedProject !== undefined) return

    const project =
      defaultProjectByCode ||
      defaultProjectByName ||
      defaultProjectById ||
      projects[0]

    selectProject(project.id)
  })

  return (
    <div className="pds-mb-sm">
      <Chosen
        ref={chosenRef}
        required
        choices={groups || []}
        groupLabel
        placeholder="Select a project"
        name="project_id"
        select
        onChange={selectProject}
        value={selectedProject}
        onClose={onChosenEvent}
        onOpen={onChosenEvent}
        data-analytics-element-id="project-select"
      />
    </div>
  )
}
